define('lq/dialogs/message',[
    'jquery',
    'underscore',
    'tpl!lq/dialogs/message.html',
    'lq/dialogs/dialog'
], function ($, _, template) {
    'use strict';

    var validationErrorMessages = {

        'empty': function(error) {
            return error.field + ' cannot be left empty';
        },

        'startsWithNumber': function(error) {
            return error.field + ' cannot start with a number';
        },

        'invalidName': function(error) {
            return error.field + ' cannot contain / \\ : or other characters not allowed in a file name, and cannot end with a dot or a space';
        },

        'invalidFilenameExtension': function(error) {
            var allowedExtensions = error.resolution.allowedExtensions;
            if (allowedExtensions.length === 1)
                return 'A ' + allowedExtensions[0] + ' file is expected.';
            return 'a file with one of the following extensions is expected: ' + allowedExtensions.join(', ');
        },

        'exceedsMaxLength': function(error) {
            return error.field + ' exceeds the maximum length of ' + error.resolution.maxLength + ' characters';
        },

        'invalidEmail': function (error) {
            return error.field + ' does not contain a valid email address';
        },

        'invalidUrl': function (error) {
            return error.field + ' does not contain a valid url';
        },

        'onlyLettersAndDigitsAllowed': function (error) {
            return error.field + ' can only contain letters and digits';
        },

        'blacklistedValue': function (error) {
            return 'value of ' + error.field + ' is not allowed';
        }

    };

    var defaultOptions = {
        title: '',
        message: '',
        formatted: false,
        ok: $.noop,
        $footer: undefined
    };

    var show = function(options) {
        options = $.extend({}, defaultOptions, options);

        var $layer = $(template());

        var $ok = $layer
            .find('#message-close')
            .on('click', function() {
                $layer.closeDialog();
                options.ok();
                return false;
            });

        $layer.find('#message-title')
            .text(options.title);

        $layer.find('#message-content')
            .text(options.message);

        if (options.formatted) {
            $('<pre>')
                .text(options.message)
                .appendTo($layer.find('#message-content'));
        }

        if (options.$footer) {
            $layer.find('footer')
                .prepend(options.$footer);
        }

        $layer.showDialog();

        $ok.trigger('focus');
    };

    var turnResponseIntoErrorMessage = function(response) {
        if (typeof response !== 'object')
            return response;
        
        if (response.rejected) {
            var errors = _.map(response.errors,
                function(error) {
                    return validationErrorMessages[error.reason](error);
                });
            return errors.join('\n\n');
        }

        var message = response.message;
            
        if (response.referenceId)
            message += '\n\nReference: ' + response.referenceId;

        return message;
    };

    var showError = function (response) {
        show({
            message: turnResponseIntoErrorMessage(response)
        });
    };

    var getResponseObject = function (jqxhr) {
        try {
            return JSON.parse(jqxhr.responseText);
        } catch (e) { }

        return jqxhr.responseText;
    };

    var showErrorFromResponse = function (jqxhr) {
        var response = getResponseObject(jqxhr);
        showError(response);
    };

    return {

        show: show,

        showError: showError,

        showErrorFromResponse: showErrorFromResponse

    };

});
